import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import centimetersToMeters from '../../../helpers/centimeters-to-meters';
import { translateState } from '../../../../models/Crate';
import formatDate from '../../../helpers/format-date';
import {toExcelFormat} from '../../../helpers/format-position';

@Component({
  selector: 'app-stock-item',
  templateUrl: './stock-item.component.html',
  styleUrls: ['./stock-item.component.scss']
})
export class StockItemComponent implements OnInit {

  @Input() crate;
  @Output() clicked = new EventEmitter();
  formatDate = formatDate;
  translateState = translateState;
  toExcelFormat = toExcelFormat;
  centimetersToMeters = centimetersToMeters;

  constructor() { }

  ngOnInit(): void {
  }

  itemClicked(column: string){
    this.clicked.emit({column, crate: this.crate});
  }
}
